<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="餐厅详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">餐厅名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">餐厅封面:</el-col>
        <el-col :span="19">
          <el-image
            :src="showForm.basic && showForm.basic.avatar"
            class="p-avatar"
          >
            <template v-slot:error class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </template>
          </el-image>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">餐厅轮播图:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="160px" class="e-carousel">
            <el-carousel-item
              v-for="item in showForm.basic.imageList || []"
              :key="item.name"
            >
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="4">送餐类型:</el-col>
        <el-col :span="20">
          <el-checkbox-group v-model="showForm.basic.shipTypehoodList" disabled>
            <el-checkbox :label="1">堂食</el-checkbox>
            <el-checkbox :label="2">打包</el-checkbox>
            <el-checkbox :label="3">外卖</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          电话:{{ showForm.basic.contact && showForm.basic.contact.tel }}
        </el-col>
        <el-col :span="12">
          地址:{{ showForm.basic.contact && showForm.basic.contact.address }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">餐厅介绍：</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { find } from '@/api/food'
export default {
  name: 'SpotDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const restaurantId = row.restaurantId
      const data = await find({
        restaurantId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
